import { createRules } from "@hilma/forms";

export const firstLoginEmailRules = createRules({
  email: {
    name: "מייל",
    required: true,
    regex:
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  },
  terms: { required: true }
});
